import { BusinessActivityEntity } from '../entities/business-activity-entity';

export default class State {
  loaded = false;

  items: Array<BusinessActivityEntity> = [];
}
